import { blockLink } from './js/blockLinks';
import { faq } from './js/faq';
import { GroupOrder } from './js/grouporder';
import { loadSVGSpritesheet } from './js/loadSVGSpritesheet';
import { shareLinks } from './js/shareLinks';
import { skipToContent } from './js/skipToContent';
import { regionDropdown } from './js/regionDropdown';

let expandBtns = [];
let menuExpandBtns = [];
let subExpandBtns = [];
let mainMenu = null;
let overlay = null;
let subMenus = [];
let mobileMenuWrapper = null;
let searchClear = [];
let searchInput = [];
let searchForm = [];
let searchHeader = null;
let searchWrapper = null;
let searchToggle = null;
let searchSubmit = null;
let header = null;
let headerHeight = "";
let body = null;
let lastScroll = 0;

window.addEventListener("load", (e) => {
  loadSVGSpritesheet.onDocumentLoad();
  header = document.getElementById("header");
  headerHeight = header.offsetHeight;
  body = document.body;
  
  /* Load any relevant modules for this page */
  /* TODO: Implement support to only run needed modules per page. */
  GroupOrder.onDocumentLoad();
  faq.onDocumentLoad();
  shareLinks.onDocumentLoad();
  blockLink.onDocumentLoad();
  skipToContent.onDocumentLoad();
  regionDropdown.onDocumentLoad();

  overlay = document.getElementById("overlay");
  expandBtns = document.querySelectorAll("[data-expand-target]");
  subExpandBtns = document.querySelectorAll("[data-sub-expand-target]");
  menuExpandBtns = document.querySelectorAll("[data-menu-target]");
  mainMenu = document.getElementById("mainMenu");
  subMenus = document.querySelectorAll(".sub-menu");
  searchHeader = document.getElementById("searchHeader");
  searchWrapper = document.getElementById("searchWrapper");
  searchToggle = document.getElementById("searchToggle");
  searchSubmit = searchWrapper.querySelector("input[type=submit]");
  mobileMenuWrapper = document.getElementById("mobileMenuWrapper");
  
  // Get sub-menu height
  for (let i = 0; i < subMenus.length; i++) {
    let height = subMenus[i].offsetHeight;
    subMenus[i].setAttribute("data-height", height);
    subMenus[i].style.height = 0;
  }

  // mobile-sub-menu height
  let mobileSubMenu = document.querySelectorAll(".mobile-sub-menu");
  for (let i = 0; i < mobileSubMenu.length; i++) {
    let height = mobileSubMenu[i].offsetHeight;
    mobileSubMenu[i].setAttribute("data-height", height);
    mobileSubMenu[i].style.height = 0;
  }

  //Get searchWrapper height
  searchWrapper.setAttribute("data-height", searchWrapper.offsetHeight);
  searchWrapper.style.height = 0;

  /*Main menu keyboard nav */
  let mainMenuButtons = mainMenu.querySelectorAll(".main-menu-item");
  for (let i = 0; i < mainMenuButtons.length; i++) {
    mainMenuButtons[i].addEventListener("click", function (e) {
      expandMenu(
        e.currentTarget,
        document.getElementById(e.currentTarget.dataset.menuTarget)
      );
    });

    mainMenuButtons[i].addEventListener("focus", function (e) {
      // Check if tab has focus from keyboard
      if (hasPseudoClass(e.currentTarget, ":focus-visible")) {
        // Check if target is search or menu toggle
        if (e.currentTarget.dataset.expandTarget) {
          // Make sure previuos target wasn't search input
          if(e.relatedTarget && e.relatedTarget.dataset.menuTarget) {
            closeMenus(true);
          }
        } else {
          closeSearch();
          expandMenu(
            e.currentTarget,
            document.getElementById(e.currentTarget.dataset.menuTarget)
          );
        }
      }
    });

    mainMenuButtons[i].addEventListener("keydown", function (e) {
      if (e.key === "Enter" && e.currentTarget.getAttribute("aria-expanded")) {
        // Prevent enter to open menu
        e.preventDefault();
        // Check if target is menu or search toggle
        if (e.currentTarget.dataset.expandTarget == "searchWrapper") {
          let expand = document.getElementById(
            e.currentTarget.dataset.expandTarget
          );
          // Get the element to focus for header toggle
          let focusOn = document.getElementById(e.currentTarget.dataset.setFocusOn);
          if (expand) {
            toggleHeaderSearch(e.currentTarget, expand, focusOn);
          }
        }
        
        if (e.currentTarget.dataset.expandTarget == "mobileMenuWrapper") {
          let expand = document.getElementById(e.currentTarget.dataset.expandTarget);
          toggleMobileMenu(e.currentTarget, expand);
        }
      }

      if (e.key === "ArrowDown") {
        e.preventDefault();
        focusSubItems(
          e.currentTarget,
          document.getElementById(e.currentTarget.dataset.menuTarget)
        );
      }
    });
  }

  //Check if focus is set by keyboard
  function hasPseudoClass(node, selector) {
    var nativeMatches = node.matches || node.msMatchesSelector;
    try {
      return nativeMatches.call(node, selector);
    } catch (error) {
      return false;
    }
  }

  //Expand submnenu
  function expandMenu(target, expand) {
    if (!target.classList.contains("open") && target.dataset.menuTarget) {
      closeMenus(false);
    }
    if (expand) {
      if (target.getAttribute("aria-expanded") == "true") {
        expand.classList.add("toggled");
        setTimeout(() => {
          expand.classList.remove("toggled");
        }, 301);
      }
      target.classList.toggle("open");
      target.setAttribute("aria-expanded", toggleAriaExpanded(target));
      expand.classList.toggle("open");

      if (target.getAttribute("aria-expanded") == "true") {
        closeSearch(null, true);
        expand.style.height = expand.dataset.height + "px";
        lockScroll();
      } else {
        expand.style.height = 0;
        releaseScroll();
      }

      overlay.classList.toggle("hide");
      window.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          closeMenus(true);
          // closeSearch();
        }
      });
    } else {
      if(target.dataset.menuTarget) {
        closeMenus(true);
      }
    }
  }

  //Set focus on subitems
  function focusSubItems(target, expand) {
    let expandFocusable = expand.querySelectorAll("[href]");
    let currentIndex = 0;

    expandFocusable[0].focus();

    expand.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        currentIndex++;
        if (expandFocusable[currentIndex]) {
          expandFocusable[currentIndex].focus();
        } else {
          currentIndex = 0;
          expandFocusable[currentIndex].focus();
        }
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        currentIndex--;
        if (expandFocusable[currentIndex]) {
          expandFocusable[currentIndex].focus();
        } else {
          currentIndex = expandFocusable.length - 1;
          expandFocusable[currentIndex].focus();
        }
      }

      if (e.key === "Tab") {
        const arr = Array.from(mainMenuButtons);
        let index = arr.indexOf(target);
        mainMenuButtons[index].focus();
      }
    });
  }

  /*Expand header elements - search & mobile menu*/
  for (let i = 0; i < expandBtns.length; i++) {
    expandBtns[i].addEventListener("click", function (e) {
      let expand = document.getElementById(e.currentTarget.dataset.expandTarget);
      let focusOn = document.getElementById(e.currentTarget.dataset.setFocusOn);

      if (e.currentTarget.dataset.expandTarget == "mobileMenuWrapper") {
        toggleMobileMenu(e.currentTarget, expand);
      } else {
        toggleHeaderSearch(e.currentTarget, expand, focusOn);
      }
    });
  }

  function toggleHeaderSearch(target, expand, focusOn) {
    expand.classList.toggle("open");
    target.setAttribute("aria-expanded", toggleAriaExpanded(target));
    
    if (expand.classList.contains("open")) {
      closeMobileMenu();
      //TODO CLOSE SEARCH
      closeMenus();
      releaseScroll();
      lockScroll(false);
      expand.style.height = expand.dataset.height + "px";
      overlay.classList.remove("hide");
    } else {
      releaseScroll();
      searchHeader.value = "";
      expand.style.height = 0;
      overlay.classList.add("hide");
    }
    
    setTimeout(() => {
      focusOn.focus();
    }, 301);

    initSearchHeader();

    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeSearch(target);
      }
    });
  }

  function closeSearch(target, preventAnimation) {
    if(!overlay.classList.contains("hide")) {
      overlay.classList.add("hide");
    }

    let labelledBy = searchWrapper.getAttribute("aria-labelledby");
    let expandBtn = document.getElementById(labelledBy);
    expandBtn.setAttribute("aria-expanded", false);
    searchWrapper.classList.remove("open");
    
    if (target != undefined || target != null) {
      target.focus();
    }

    if (preventAnimation) {
      searchWrapper.classList.add("hidden");
      setTimeout(() => {
        searchWrapper.classList.remove("hidden");
      }, 301);
    }
    
    searchWrapper.style.height = 0;
    searchHeader.value = "";
  }

  //Handle search clear
  searchClear = document.querySelectorAll(".clear-search");
  for (let i = 0; i < searchClear.length; i++) {
    searchClear[i].addEventListener("click", function (e) {
      let clearInput = document.getElementById(e.currentTarget.dataset.clearSearch);
      e.preventDefault();
      clearSerch(searchClear[i], clearInput);
    });

    searchClear[i].addEventListener("keyup", function (e) {
      if(e.key === "Enter") {
        let clearInput = document.getElementById(e.currentTarget.dataset.clearSearch);
        e.preventDefault();
        clearSerch(searchClear[i], clearInput);
      }
    });
  }
  
  function clearSerch(searchClear, clearInput) {
    e.preventDefault();
      searchClear.classList.add("hidden");
      clearInput.value = "";
      clearInput.focus();
  }

  //Handle search input
  searchInput = document.querySelectorAll("input[type=search]");
  for (let i = 0; i < searchInput.length; i++) {
    searchInput[i].addEventListener("keyup", function (e) {
      let clearInput = document.getElementById(searchInput[i].id + "Clear");
      if(searchInput[i].value.length > 0) {
        clearInput.classList.remove("hidden");
      } else {
        clearInput.classList.add("hidden");
      }

      if(e.key === "Enter") {
        e.preventDefault();
        if(searchInput[i].value.length > 0) {
          e.currentTarget.form.submit();
        }
      }
    });
  }

  //Handle tab loop for header search
  function initSearchHeader() {
    searchSubmit.addEventListener("blur", function (e) {
      searchToggle.focus();
    });
  }

  //Handle search submiting form
  searchForm = document.querySelectorAll(".search-form");
  for (let i = 0; i < searchForm.length; i++) {
    let formInput = searchForm[i].querySelectorAll("input");
    searchForm[i].addEventListener("submit", function (e) {
      e.preventDefault();
      if(formInput[0].value.length > 0) {
        searchForm[i].submit();
      }
    });
  }

  function toggleMobileMenu(target, expand) {
    expand.classList.toggle("open");
    target.setAttribute("aria-expanded", toggleAriaExpanded(target));

    if (expand.classList.contains("open")) {
      lockScroll(true);
      overlay.classList.remove("hide");
      closeSearch(null, true);
    } else {
      releaseScroll();
      closeMobileSubMenus();
      overlay.classList.add("hide");
    }
  }

  function lockScroll(isMobile) {
    //Prevent scrolling the content below the menu by setting it to an fixed postion
    body.classList.add("menuOpen");
    if (isMobile) {
      body.classList.add("mobileMenuOpen");
    }
  }

  function releaseScroll() {
    setTimeout(() => {
      body.classList.remove("menuOpen");
      body.classList.remove("mobileMenuOpen");
      body.classList.add("scrollUp");
    }, 3);
  }

  /*Mobile sub menu expand button*/
  for (let i = 0; i < subExpandBtns.length; i++) {
    subExpandBtns[i].addEventListener("click", function (e) {
      let expand = document.getElementById(
        e.currentTarget.dataset.subExpandTarget
      );
      if (expand) {
        expand.classList.toggle("open");
        e.currentTarget.setAttribute(
          "aria-expanded",
          toggleAriaExpanded(e.currentTarget)
        );
        if(expand.classList.contains("open")) {
          expand.style.height = expand.dataset.height + "px";
        } else {
          expand.style.height = 0;
        }
      }
    });
  }

  function toggleAriaExpanded(target) {
    let targetExpanded = target.getAttribute("aria-expanded");

    if (targetExpanded == "true") {
      targetExpanded = "false";
    } else {
      targetExpanded = "true";
    }

    return targetExpanded;
  }

  /* Overlay - hide and close all expanded */
  overlay.addEventListener("click", function (e) {
    closeMenus(true);
    closeSearch();
    releaseScroll();
  });

  function closeMenus(toggleMenuItem) {
    //Close main menus
    for (let i = 0; i < menuExpandBtns.length; i++) {
      menuExpandBtns[i].classList.remove("open");
      menuExpandBtns[i].setAttribute("aria-expanded", false);
      let close = document.getElementById(menuExpandBtns[i].dataset.menuTarget);
      close.classList.remove("open");
      close.style.height = 0;

      if (toggleMenuItem) {
        close.classList.add("toggled");
        setTimeout(() => {
          close.classList.remove("toggled");
        }, 301);
      }
    }
    overlay.classList.add("hide");
  }

  //Close mobile main menu
  function closeMobileMenu() {
    let labelledBy = mobileMenuWrapper.getAttribute("aria-labelledby");
    let expandBtn = document.getElementById(labelledBy);
    expandBtn.setAttribute("aria-expanded", false);
    mobileMenuWrapper.classList.add("hidden");
    setTimeout(() => {
      mobileMenuWrapper.classList.remove("open");
      mobileMenuWrapper.classList.remove("hidden");
    }, 301);

    closeMobileSubMenus();
    overlay.classList.add("hide");
  }

  function closeMobileSubMenus() {
    for (let i = 0; i < subExpandBtns.length; i++) {
      let sibling = subExpandBtns[i].previousElementSibling;
      if (!sibling.classList.contains("active")) {
        subExpandBtns[i].setAttribute("aria-expanded", false);
        let close = document.getElementById(
          subExpandBtns[i].dataset.subExpandTarget
        );
        close.classList.remove("open");
        close.classList.add("closing-mobile-menu");
        setTimeout(() => {
          close.style.height = 0;
          close.classList.remove("closing-mobile-menu");
        }, 301);
      }
    }
  }
});

window.addEventListener("scroll", () => {
  const currentScroll = window.scrollY;

  if (!body.classList.contains("menuOpen")) {
    if (currentScroll > headerHeight) {
      body.classList.add("scrolledPast");
    } else {
      body.classList.remove("scrolledPast");
    }

    if (currentScroll < lastScroll && body.classList.contains("scrolledPast")) {
      body.classList.add("scrollUp");
    } else {
      body.classList.remove("scrollUp");
    }
  }

  lastScroll = currentScroll;
});
